import PageHeader from "../components/PageHeader";
import FleetSection from "../components/FleetSection";
import ContactCTA from "../components/ContactCTA";

export default function Flotte() {
  return (
    <div data-testid="page-flotte">
      <PageHeader
        overline="Nos hélicoptères"
        title="La flotte."
        lead="Trois appareils, Robinson R22 pour l'école et la découverte, Robinson R44 pour la polyvalence à quatre places, Airbus AS350 pour l'événementiel et le VIP."
      />
      <FleetSection />
      <ContactCTA />
    </div>
  );
}
